var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.56 0h58.88C179.2 0 192 12.8 192 66.56v58.88c0 53.76-12.8 66.56-66.56 66.56H66.56C12.8 192 0 179.2 0 125.44V66.56C0 12.8 12.8 0 66.56 0z",
    fill: "#2787f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.23 66.146c0.88956-2.9664 0-5.1462-4.2338-5.1462h-14c-3.5597 0-5.2008 1.883-6.0909 3.9594 0 0-7.1195 17.354-17.205 28.626-3.263 3.263-4.7463 4.3012-6.5262 4.3012-0.8898 0-2.178-1.0382-2.178-4.0044v-27.736c0-3.5598-1.0331-5.1462-3.9998-5.1462h-22c-2.2245 0-3.5624 1.6522-3.5624 3.218 0 3.3746 5.0426 4.1528 5.5624 13.645v20.617c0 4.5201-0.8163 5.3396-2.5962 5.3396-4.7461 0-16.291-17.431-23.138-37.377-1.3419-3.8767-2.6878-5.4427-6.2658-5.4427h-14c-4 0-4.8 1.883-4.8 3.9594 0 3.7081 4.7463 22.1 22.1 46.424 11.569 16.612 27.868 25.616 42.7 25.616 8.8991 0 10-2 10-5.445v-12.555c0-4 0.84305-4.7983 3.6611-4.7983 2.0764 0 5.6361 1.0382 13.942 9.0475 9.4924 9.4924 11.057 13.751 16.397 13.751h14c4 0 6-2 4.8462-5.9469-1.2626-3.9337-5.7947-9.641-11.808-16.406-3.2632-3.8562-8.1577-8.009-9.641-10.086-2.0764-2.6694-1.4831-3.8563 0-6.2292 0 0 17.057-24.028 18.837-32.185z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.e4c69c6d0e1b5b018820da2320a112b1.svg";
export { ForwardRef as ReactComponent };